import React from "react";

function SelfServiceIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      overflow="hidden"
      viewBox="0 0 183 179"
      {...props}
    >
      <path
        className="fill-current"
        fillRule="evenodd"
        stroke="#FFF"
        strokeMiterlimit="8"
        strokeWidth="13.75"
        d="M10 88.5C10 44.041 46.71 8 92 8s82 36.041 82 80.5S137.29 169 92 169s-82-36.041-82-80.5z"
      ></path>
      <g fill="#FFF">
        <path d="M103.83 108.587V98.32a3.952 3.952 0 00-1.51-3.033 20.73 20.73 0 00-7.4-3.603 21.617 21.617 0 00-6.25-.949 23.83 23.83 0 00-6.26.947 24.35 24.35 0 00-7.39 3.603 3.929 3.929 0 00-1.52 3.033v10.267zM88.67 71.403a8.716 8.716 0 00-8.72 8.717c0 4.815 3.9 8.718 8.72 8.718 4.81 0 8.71-3.903 8.71-8.718 0-4.814-3.9-8.717-8.71-8.717zm0 15.142a5.753 5.753 0 01-5.17-3.212h10.33a5.749 5.749 0 01-5.16 3.212zm-19.5-47.887l1.65-1.649 4.67 4.666-1.65 1.65zm12.84 3.017l4.66-4.667 1.65 1.65-4.66 4.667zm-4.43-7.342h2.34v7h-2.34z"></path>
        <path d="M109.67 87.3v32.2h-42V58.833h42v13.612c.13-.09.25-.183.39-.265a8.134 8.134 0 014.22-1.181h.05V50.667A4.673 4.673 0 00109.67 46h-42A4.681 4.681 0 0063 50.667v77a4.68 4.68 0 004.67 4.666h42a4.672 4.672 0 004.66-4.666V95zM84.58 50.667h8.17c.97 0 1.75.783 1.75 1.75 0 .966-.78 1.75-1.75 1.75h-8.17c-.96 0-1.75-.784-1.75-1.75 0-.967.79-1.75 1.75-1.75zm-5.83 0c.97 0 1.75.783 1.75 1.75 0 .966-.78 1.75-1.75 1.75S77 53.383 77 52.417c0-.967.78-1.75 1.75-1.75z"></path>
        <path d="M117.83 97.333v30.334c0 4.508-3.66 8.161-8.16 8.166l-.94-.134 7 5.006a4.666 4.666 0 005.93-.417l13.39-12.738a4.664 4.664 0 00.65-5.994l-4.73-6.992v-.027l-4.77-24.173a4.36 4.36 0 00-.39-1.106 3.985 3.985 0 00-.35-.727l-7.13-11.78a4.668 4.668 0 00-7.99 4.832l6.83 11.274.69 3.472z"></path>
      </g>
    </svg>
  );
}

export default SelfServiceIcon;